"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/deduct_saas/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _fileImage = _interopRequireDefault(require("@/components/fileImage.vue"));
var _market = _interopRequireDefault(require("@/components/market.vue"));
var _goodForm = _interopRequireDefault(require("./goodForm.vue"));
var _qrcode = _interopRequireDefault(require("qrcode"));
var _default = exports.default = {
  components: {
    Market: _market.default,
    FileImage: _fileImage.default,
    GoodForm: _goodForm.default
  },
  data: function data() {
    return {
      document: {},
      attachments: [],
      listLoading: true,
      dialogFormVisible: false,
      qrImg: '',
      //存储当前商品的二维码
      pk: 0,
      good_img: '',
      //存储当前商品的图片
      flag: null,
      is_day_nums: false // 是否按天数扣费
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.pk = this.$route.query.id;
            this.getList(); // 等待getList完成
            _context.next = 4;
            return this.getQRCode();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: {
    // 待选参数_字符串——done
    parmaValue: function parmaValue() {
      // 将parameter_value数组的内容提取出来，变成字符串
      if (this.document.parameter_value != '无') {
        var ruleStr = JSON.parse(this.document.parameter_value);
        if (Array.isArray(ruleStr)) {
          return ruleStr.join(',');
        }
        return ruleStr;
      }
    }
  },
  methods: {
    // 根据id获取产品详情
    // 根据id获取产品详情
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      // 请求产品信息
      (0, _request.default)({
        url: "/Goods/".concat(this.pk, "/"),
        method: 'get',
        params: {
          shop: this.$user.data.shop
        }
      }).then(function (res) {
        if (res.data) {
          _this.document = res.data;
        }
        _this.listLoading = false;
      });

      // 请求图片
      (0, _request.default)({
        url: "/system/goods/goods_image_get/?goods_id=".concat(this.pk),
        method: 'get'
      }).then(function (response) {
        // 保存为base64格式
        _this.good_img = "data:image/png;base64,".concat(response.data);
      });
    },
    // 页头--返回上级页面
    goBack: function goBack() {
      // this.$router.go(-1)
      // 返回列表页
      this.$router.push({
        name: 'goodList'
      });
    },
    // 根据id生成二维码
    getQRCode: function () {
      var _getQRCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, str;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 生成二维码图片
              // 获取当前路由中得id
              id = this.$route.query.id;
              str = "https://userzc.99zuji.com/#/pages/mine/addOrder?id=".concat(id); //   const str = `alipays://platformapi/startapp?appId=2021005108600471&page=pages/mine/addOrder?id=${id}`
              _context2.next = 4;
              return _qrcode.default.toDataURL(str);
            case 4:
              this.qrImg = _context2.sent;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getQRCode() {
        return _getQRCode.apply(this, arguments);
      }
      return getQRCode;
    }(),
    handleFilter: function handleFilter() {
      this.getList();
    },
    // 右上角button
    handleEdit: function handleEdit() {
      // this.getList()
      this.dialogFormVisible = true;
      this.getCharge(); // 获取扣费方式
    },
    getCharge: function getCharge() {
      var _this2 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (res) {
        if (res.data) {
          _this2.is_day_nums = res.data.is_day_nums;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 修改产品———done
    editGood: function editGood(val) {
      var _this3 = this;
      this.listLoading = true;
      console.log(val, '修改产品');
      // 2.发送请求添加产品
      (0, _request.default)({
        url: "/Goods/".concat(this.pk, "/"),
        method: 'put',
        params: {
          shop: this.$user.data.shop
        },
        data: {
          name: val.name,
          cost_type: val.cost_type,
          day_num: val.day_num,
          order_mode: val.order_mode,
          //   active: val.active,
          active: val.active == '拒绝' ? '待审核' : val.active == '0' ? '下架' : val.active == '1' ? '上架' : val.active,
          cost_money: val.cost_money,
          deposit: val.deposit,
          order_type: val.order_type,
          money: val.money,
          goods_cate: val.goods_cate || 3,
          cost_num: val.cost_num,
          cost_rule: val.cost_rule,
          q_cost_day: val.q_cost_day,
          d_cost_type: val.d_cost_type,
          d_cost_money: val.d_cost_money,
          remark: val.remark,
          parameter: val.parameter || '无',
          parameter_value: val.parameter_value || '无',
          shop: this.$user.data.shop,
          // 以下为新增字段
          brand: val.brand || '自有品牌',
          model: val.model || '无',
          // 需要传递默认值
          main_class: val.main_class || GENERAL,
          sub_class: val.sub_class || GENERAL_other,
          // good_img:val.good_img
          shou_money: val.shou_money,
          shou_cost_num: val.shou_cost_num
        }
      }).then(function (res) {
        if (res.code === 200 || 201) {
          // 图片更新时进行上传
          console.log(val.flag, "flag");
          if (val.flag != false) {
            var formData = new FormData();
            formData.append('file', val.good_img);
            formData.append('goods_id', _this3.pk);
            (0, _request.default)({
              url: "/system/goods/goods_file_up/",
              method: 'post',
              data: formData
            }).then(function (res) {
              if (res.code === 200) {
                // 获取图片进行展示
                (0, _request.default)({
                  url: "/system/goods/goods_image_get/?goods_id=".concat(_this3.pk),
                  method: 'get'
                }).then(function (res) {
                  // 保存为base64格式
                  _this3.good_img = "data:image/png;base64,".concat(res.data);
                });
              } else {
                console.log('图片上传失败');
              }
            }).catch(function (err) {
              console.log(err, '图片上传失败');
            });
          } else {
            console.log("不上传图片");
          }
          // 1.提示添加成功
          _this3.$message({
            message: "\u4FEE\u6539\u6210\u529F",
            type: 'success'
          });
          // 2.关闭新增产品form
          _this3.dialogFormVisible = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 取消新增产品
    cancel: function cancel() {
      this.dialogFormVisible = false;
    }
  }
};